module.exports = __webpack_public_path__ + "img/coin.1315f41b.svg";